import { render, staticRenderFns } from "./AmountReceivedTemplate.vue?vue&type=template&id=772efd06&scoped=true&"
import script from "./AmountReceivedTemplate.vue?vue&type=script&lang=js&"
export * from "./AmountReceivedTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772efd06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772efd06')) {
      api.createRecord('772efd06', component.options)
    } else {
      api.reload('772efd06', component.options)
    }
    module.hot.accept("./AmountReceivedTemplate.vue?vue&type=template&id=772efd06&scoped=true&", function () {
      api.rerender('772efd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/AmountReceivedTemplate.vue"
export default component.exports